﻿var holydaysArray = new Array();
// 2013
holydaysArray['2013-03-24'] = 'Palmesøndag';
holydaysArray['2013-03-28'] = 'Skærtorsdag';
holydaysArray['2013-03-29'] = 'Langfredag';
holydaysArray['2013-03-31'] = 'Påskedag';
holydaysArray['2013-04-01'] = '2. påskedag';
holydaysArray['2013-04-26'] = 'Store bededag';
holydaysArray['2013-05-09'] = 'Kristi himmelfartsdag';
holydaysArray['2013-05-19'] = 'Pinsedag';
holydaysArray['2013-05-20'] = '2. pinsedag';

// 2014
holydaysArray['2014-04-13'] = 'Palmesøndag';
holydaysArray['2014-04-17'] = 'Skærtorsdag';
holydaysArray['2014-04-18'] = 'Langfredag';
holydaysArray['2014-04-20'] = 'Påskedag';
holydaysArray['2014-04-21'] = '2. påskedag';
holydaysArray['2014-05-16'] = 'Store bededag';
holydaysArray['2014-05-29'] = 'Kristi himmelfartsdag';
holydaysArray['2014-06-08'] = 'Pinsedag';
holydaysArray['2014-06-09'] = '2. pinsedag';

// 2015
holydaysArray['2015-03-29'] = 'Palmesøndag';
holydaysArray['2015-04-02'] = 'Skærtorsdag';
holydaysArray['2015-04-03'] = 'Langfredag';
holydaysArray['2015-04-05'] = 'Påskedag';
holydaysArray['2015-04-06'] = '2. påskedag';
holydaysArray['2015-05-01'] = 'Store bededag';
holydaysArray['2015-05-14'] = 'Kristi himmelfartsdag';
holydaysArray['2015-05-24'] = 'Pinsedag';
holydaysArray['2015-05-25'] = '2. pinsedag';

// 2016
holydaysArray['2016-03-20'] = 'Palmesøndag';
holydaysArray['2016-03-24'] = 'Skærtorsdag';
holydaysArray['2016-03-25'] = 'Langfredag';
holydaysArray['2016-03-27'] = 'Påskedag';
holydaysArray['2016-03-28'] = '2. påskedag';
holydaysArray['2016-04-22'] = 'Store bededag';
holydaysArray['2016-05-05'] = 'Kristi himmelfartsdag';
holydaysArray['2016-05-15'] = 'Pinsedag';
holydaysArray['2016-05-16'] = '2. pinsedag';

// 2017
holydaysArray['2017-04-09'] = 'Palmesøndag';
holydaysArray['2017-04-13'] = 'Skærtorsdag';
holydaysArray['2017-04-14'] = 'Langfredag';
holydaysArray['2017-04-16'] = 'Påskedag';
holydaysArray['2017-04-17'] = '2. påskedag';
holydaysArray['2017-05-12'] = 'Store bededag';
holydaysArray['2017-05-25'] = 'Kristi himmelfartsdag';
holydaysArray['2017-06-04'] = 'Pinsedag';
holydaysArray['2017-06-05'] = '2. pinsedag';

// 2018
holydaysArray['2018-03-25'] = 'Palmesøndag';
holydaysArray['2018-03-29'] = 'Skærtorsdag';
holydaysArray['2018-03-30'] = 'Langfredag';
holydaysArray['2018-04-01'] = 'Påskedag';
holydaysArray['2018-04-02'] = '2. påskedag';
holydaysArray['2018-04-27'] = 'Store bededag';
holydaysArray['2018-05-10'] = 'Kristi himmelfartsdag';
holydaysArray['2018-05-20'] = 'Pinsedag';
holydaysArray['2018-05-21'] = '2. pinsedag';

// 2019
holydaysArray['2019-04-14'] = 'Palmesøndag';
holydaysArray['2019-04-18'] = 'Skærtorsdag';
holydaysArray['2019-04-19'] = 'Langfredag';
holydaysArray['2019-04-21'] = 'Påskedag';
holydaysArray['2019-04-22'] = '2. påskedag';
holydaysArray['2019-05-17'] = 'Store bededag';
holydaysArray['2019-05-30'] = 'Kristi himmelfartsdag';
holydaysArray['2019-06-09'] = 'Pinsedag';
holydaysArray['2019-06-10'] = '2. pinsedag';

// 2020
holydaysArray['2020-04-05'] = 'Palmesøndag';
holydaysArray['2020-04-09'] = 'Skærtorsdag';
holydaysArray['2020-04-10'] = 'Langfredag';
holydaysArray['2020-04-12'] = 'Påskedag';
holydaysArray['2020-04-13'] = '2. påskedag';
holydaysArray['2020-05-08'] = 'Store bededag';
holydaysArray['2020-05-21'] = 'Kristi himmelfartsdag';
holydaysArray['2020-05-31'] = 'Pinsedag';
holydaysArray['2020-06-01'] = '2. pinsedag';

//2021
holydaysArray['2021-03-28'] = 'Palmesøndag';
holydaysArray['2021-04-01'] = 'Skærtorsdag';
holydaysArray['2021-04-02'] = 'Langfredag';
holydaysArray['2021-04-04'] = 'Påskedag';
holydaysArray['2021-04-05'] = '2. påskedag';
holydaysArray['2021-05-30'] = 'Store bededag';
holydaysArray['2021-05-13'] = 'Kristi himmelfartsdag';
holydaysArray['2021-05-23'] = 'Pinsedag';
holydaysArray['2021-05-24'] = '2. pinsedag';

//2022
holydaysArray['2022-04-10'] = 'Palmesøndag';
holydaysArray['2022-04-14'] = 'Skærtorsdag';
holydaysArray['2022-04-15'] = 'Langfredag';
holydaysArray['2022-04-17'] = 'Påskedag';
holydaysArray['2022-04-18'] = '2. påskedag';
holydaysArray['2022-05-13'] = 'Store bededag';
holydaysArray['2022-05-26'] = 'Kristi himmelfartsdag';
holydaysArray['2022-06-05'] = 'Pinsedag';
holydaysArray['2022-06-06'] = '2. pinsedag';

//2023
holydaysArray['2023-04-02'] = 'Palmesøndag';
holydaysArray['2023-04-06'] = 'Skærtorsdag';
holydaysArray['2023-04-07'] = 'Langfredag';
holydaysArray['2023-04-09'] = 'Påskedag';
holydaysArray['2023-04-10'] = '2. påskedag';
holydaysArray['2023-05-05'] = 'Store bededag';
holydaysArray['2023-05-18'] = 'Kristi himmelfartsdag';
holydaysArray['2023-05-28'] = 'Pinsedag';
holydaysArray['2023-05-29'] = '2. pinsedag';

//2024
holydaysArray['2024-03-24'] = 'Palmesøndag';
holydaysArray['2024-03-28'] = 'Skærtorsdag';
holydaysArray['2024-03-29'] = 'Langfredag';
holydaysArray['2024-03-31'] = 'Påskedag';
holydaysArray['2024-04-01'] = '2. påskedag';
holydaysArray['2024-04-26'] = 'Store bededag';
holydaysArray['2024-05-09'] = 'Kristi himmelfartsdag';
holydaysArray['2024-05-19'] = 'Pinsedag';
holydaysArray['2024-05-20'] = '2. pinsedag';

//2025
holydaysArray['2025-04-13'] = 'Palmesøndag';
holydaysArray['2025-04-17'] = 'Skærtorsdag';
holydaysArray['2025-04-18'] = 'Langfredag';
holydaysArray['2025-04-20'] = 'Påskedag';
holydaysArray['2025-04-21'] = '2. påskedag';
holydaysArray['2025-05-16'] = 'Store bededag';
holydaysArray['2025-05-29'] = 'Kristi himmelfartsdag';
holydaysArray['2025-06-08'] = 'Pinsedag';
holydaysArray['2025-06-09'] = '2. pinsedag';


function calculateEaster(year) {
    const f = Math.floor;
    const a = year % 19;
    const b = f(year / 100);
    const c = year % 100;
    const d = f(b / 4);
    const e = b % 4;
    const f1 = f((b + 8) / 25);
    const g = f((b - f1 + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = f(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = f((a + 11 * h + 22 * l) / 451);
    const month = f((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
}

function formatDateUTC(date) {
    return date.toISOString().split('T')[0];
}

function addHolidayUTC(year, offsetDays, name) {
    const easter = calculateEaster(year);
    const date = new Date(Date.UTC(easter.getUTCFullYear(), easter.getUTCMonth(), easter.getUTCDate() + offsetDays));
    holydaysArray[formatDateUTC(date)] = name;
}

for (let year = 2024; year <= 2049; year++) {
    addHolidayUTC(year, -7, "Palmesøndag");
    addHolidayUTC(year, -3, "Skærtorsdag");
    addHolidayUTC(year, -2, "Langfredag");
    addHolidayUTC(year, 0, "Påskedag");
    addHolidayUTC(year, 1, "2. påskedag");
    addHolidayUTC(year, 26, "Store bededag");
    addHolidayUTC(year, 39, "Kristi himmelfartsdag");
    addHolidayUTC(year, 49, "Pinsedag");
    addHolidayUTC(year, 50, "2. pinsedag");
}

//console.log(holydaysArray);

Date.prototype.isHolyday = function () {
    var date = new Date(this.getTime());
    
    // Weekender
    if (date.getDay() === 0 || date.getDay() === 6) {
        return true;
    }

    // Nytår
    if (date.getMonth() === 0 && date.getDate() === 1) {
        return true;
    }

    // Julen
    if (date.getMonth() === 11 && (date.getDate() === 24 || date.getDate() === 25 || date.getDate() === 26)) {
        return true;
    }
    
    // Forskydelige helligdage
    if (holydaysArray[date.toString('yyyy-MM-dd')] !== undefined) {
        return true;
    }

    return false;
}

Date.prototype.getHolydayName = function () {
    var date = new Date(this.getTime());

    // Forskydelige helligdage
    if (holydaysArray[date.toString('yyyy-MM-dd')] !== undefined) {
        return holydaysArray[date.toString('yyyy-MM-dd')];
    }

    // Nytår
    if (date.getMonth() === 0 && date.getDate() === 1) {
        return 'Nytårsdag';
    }

    // Julen
    if (date.getMonth() === 11 && date.getDate() === 24) {
        return 'Juleaftensdag';
    }

    if (date.getMonth() === 11 && date.getDate() === 25) {
        return 'Juledag';
    }

    if (date.getMonth() === 11 && date.getDate() === 26) {
        return '2. juledag';
    }

    // Weekender
    if (date.getDay() === 0 || date.getDay() === 6) {
        return 'Weekend';
    }
    

    return 'Hverdag';
}